import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import {
  BodyTextMedium,
  Button,
  HeadingText20,
  HeadingText50,
  Icon,
} from '@modernhealth/vital-components';

const Wrapper = styled.div({
  position: 'absolute',
  top: 32,
  height: 'calc(100% - 32px)',
  width: '100%',
  backgroundColor: 'white',
  padding: 16,
});

const Link = styled.a({
  display: 'inline',
  cursor: 'pointer',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
  svg: {
    display: 'inline',
  },
});

const HeadlineContainer = styled.div({
  display: 'flex',
  flex: 1,
  alignItems: 'top',
  h2: {
    margin: 0,
  },
  marginTop: 28,
  marginBottom: 36,
});

const Image = styled.img({
  display: 'inline',
  height: 60,
  width: 60,
  borderRadius: 3,
  padding: 8,
  marginRight: 16,
  marginLeft: 0,
});

const ButtonContainer = styled.div({
  position: 'absolute',
  bottom: 0,
  marginBottom: 20,
  width: 'calc(100% - 32px)',
});

interface ChatResourceInfoPanelProps {
  toggleResource: (item: any) => void;
  toggleShowResourceInfoPanel: () => void;
  resourcesToAdd: any[];
  selectedItem: any;
}

const ChatResourceInfoPanel: React.FC<ChatResourceInfoPanelProps> = ({
  toggleResource,
  toggleShowResourceInfoPanel,
  resourcesToAdd,
  selectedItem,
}) => {
  const index = resourcesToAdd.findIndex(
    (resource) => resource.uniqueKey === selectedItem.uniqueKey,
  );
  const alreadyAdded = index >= 0;

  return (
    <Wrapper>
      <Link
        onClick={() => {
          toggleShowResourceInfoPanel();
        }}
      >
        <BodyTextMedium>
          <Icon name="chevron-left" />
          Back
        </BodyTextMedium>
      </Link>
      <HeadlineContainer>
        <Image
          style={{
            backgroundColor: selectedItem.color,
          }}
          src={selectedItem.image}
          alt="resource-item"
        />
        <div>
          <HeadingText50>{selectedItem.name}</HeadingText50>
          <BodyTextMedium>
            {selectedItem.topics[0].name !== 'all_your_benefits_page.other_benefit'
              ? selectedItem.topics[0].name
              : 'Other benefits'}
          </BodyTextMedium>
        </div>
      </HeadlineContainer>
      <div>
        <HeadingText20>About this benefit</HeadingText20>
        <BodyTextMedium>{selectedItem.description}</BodyTextMedium>
      </div>
      <ButtonContainer>
        <Button
          size="medium"
          fluid
          onClick={() => {
            toggleResource(selectedItem);
          }}
          variant={alreadyAdded ? 'destructive' : 'primary'}
        >
          {alreadyAdded ? 'Remove from message' : 'Attach to message'}
        </Button>
      </ButtonContainer>
    </Wrapper>
  );
};

const mapState = (state) => ({
  resourcesToAdd: state.resources.resourcesToAdd,
  selectedItem: state.resources.selectedItem,
});

const mapDispatch = (dispatch) => ({
  toggleResource: dispatch.resources.toggleResource,
  toggleShowResourceInfoPanel: dispatch.resources.toogleShowResourceInfoPanel,
});

export default connect(mapState, mapDispatch)(ChatResourceInfoPanel);
